import { type SvgIconProps } from '@mui/material';
import { type ComponentType } from 'react';
import { type PaymentProvider } from '../../types/payment';
import { PAYMENT_METHOD, type EnumValues } from '../../types/enums';
import { UsdtBep20Icon, UsdtTrc20Icon } from '../../assets/icons/payment-providers';

//TODO: min deposit amount should be fetch from BE
export const CRYPTO_MIN_DEPOSIT_AMOUNT = 10;

export type CryptoPaymentProvider = EnumValues<Pick<typeof PAYMENT_METHOD, 'USDT_BEP20' | 'USDT_TRC20'>>;

export type CryptoPaymentProviderConfig = PaymentProvider & {
  title: string;
  networkLabel: string;
  tokenLabel: string;
  displayName: string;
  icon: ComponentType<SvgIconProps>;
  minDepositAmount: number;
};

export const cryptoPaymentProviders: CryptoPaymentProviderConfig[] = [
  {
    label: 'USDT BEP20',
    value: PAYMENT_METHOD.USDT_BEP20,
    aliases: ['BEP20'],
    icon: UsdtBep20Icon,
    title: 'USDT',
    networkLabel: 'BEP20',
    tokenLabel: 'USDT BEP20',
    displayName: 'Tether BEP20',
    minDepositAmount: CRYPTO_MIN_DEPOSIT_AMOUNT,
  },
  {
    label: 'USDT TRC20',
    value: PAYMENT_METHOD.USDT_TRC20,
    aliases: ['TRC20'],
    icon: UsdtTrc20Icon,
    title: 'USDT',
    networkLabel: 'TRC20',
    tokenLabel: 'USDT TRC20',
    displayName: 'Tether TRC20',
    minDepositAmount: CRYPTO_MIN_DEPOSIT_AMOUNT,
  },
];

export const defaultCryptoPaymentProvider = cryptoPaymentProviders[0];

export const getCryptoProviderConfig = (provider: string | null) =>
  cryptoPaymentProviders.find((item) => item.value === provider) ?? defaultCryptoPaymentProvider;
